import React from 'react';

const Dashboard = () => {

  return (
    <div>
      <h2>Bienvenue sur le tableau de bord protégé</h2>
      <p>Cette section est réservée aux utilisateurs authentifiés.</p>
    </div>
  );
};

export default Dashboard;